import { type JSX } from 'react';

import { Input } from '@/ui';

interface TextFieldProps {
  id: string;
  label: string | JSX.Element;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  description?: string;
}

const TextField = ({
  id,
  label,
  value,
  onChange,
  error,
  required,
  disabled,
  placeholder,
  description
}: TextFieldProps) => (
  <div className="flex flex-col gap-1">
    <Input
      id={id}
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
      helpText={description}
      error={error}
      aria-required={required || undefined}
    />
  </div>
);

export default TextField;
